import { downloadBlob } from 'clickNgo/helpers/common'

import { DOWNLOAD_APL_DOCUMENT_ENDPOINT } from '../configs'

interface IDownloadAplDocumentParameters {
  documentId: number
  fileName: string
}

export const downloadAplDocument = async ({
  documentId,
  fileName,
}: IDownloadAplDocumentParameters) => {
  const response = await fetch(`${DOWNLOAD_APL_DOCUMENT_ENDPOINT}/${documentId}`)

  const blob = await response.blob()

  return downloadBlob(fileName, blob)
}
